export default {
  'Blog': 'Blog',
  'Biconomy Blog': 'Biconomy Blog',
  'blog_title': 'Everything you need to know about crypto',
  'Enter Key Words': 'Enter Key Words',
  'Tutorials': 'Tutorials',
  'Articles': 'Articles',
  'Get More': 'Get More',

  'Share': 'Share',
  'Read More': 'Read More',
};
